import React, { useRef, useState } from "react";
import { SelectPicker } from "rsuite";
import DIAL_CODES from "./DialCodesList.json";
import { TrimText } from "./commonfunction";

const VALUE_TYPES = {
  DIAL_CODE: "dial_code",
  PHONE_NUMBER: "phone_number",
};

export default function BusinessPhoneInput({ name, defaultValue = null, disabled = false, placeholder = "Enter phone number", className = "form-control", defaultCode = "+353", value = {}, onChange = () => {}, onBlur = () => {} }) {
  const [dialCodeOptions] = useState(
    DIAL_CODES.map((item) => ({
      label: `${item?.value} ${TrimText(item?.label, 15)}`,
      value: item.value,
    }))
  );

  const numberRef = useRef();
  const codeRef = useRef();
  const [selectedCode, setSelectedCode] = useState(defaultCode);

  const parseValue = (valueData) => {
    if (valueData && typeof valueData === "object") {
      return {
        code: valueData.countryCode || defaultCode,
        number: valueData.phone || "",
      };
    }
    return { code: defaultCode, number: "" };
  };

  const handleChange = (type, val) => {
    const number = type === VALUE_TYPES.DIAL_CODE ? numberRef?.current?.value : val;
    const code = type === VALUE_TYPES.DIAL_CODE ? val : selectedCode;

    const phoneObj = {
      countryCode: code,
      phone: number,
      fullNumber: `${code} ${number}`,
    };

    onChange(phoneObj);
  };

  const parsed = parseValue(value);

  return (
    <div className="input-group">
      <div className="d-inline" style={{ display: "flex", alignItems: "center", height: "38px" }}>
        <SelectPicker
          ref={codeRef}
          size="lg"
          name={name}
          disabled={disabled}
          onChange={(e) => {
            setSelectedCode(e);
            handleChange(VALUE_TYPES.DIAL_CODE, e);
          }}
          className="phone_input_dial_code inc-height"
          value={parsed.code}
          data={dialCodeOptions}
          renderValue={(val) => <span>{val}</span>}
          cleanable={false}
        />
      </div>
      <input
        type="text"
        disabled={disabled}
        onKeyDown={(e) => {
          const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete"];

          // Allow digits (0-9), navigation keys, etc.
          if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
            e.preventDefault();
          }
        }}
        ref={numberRef}
        style={{ borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
        className={"form-control"}
        value={parsed.number}
        onChange={(e) => handleChange(VALUE_TYPES.PHONE_NUMBER, e.target.value)}
        name={name}
        onBlur={onBlur}
        placeholder={placeholder}
      />
    </div>
  );
}
